import React, { useState } from 'react'
import { FaSave } from "react-icons/fa";
import { FaLocationArrow } from "react-icons/fa";
import { FaCodeCompare } from "react-icons/fa6";




function SMTPSetting() {

    const [EnableSSL, setEnableSSL] = useState(false)
    const [testmail, settestmail] = useState('')
    return (
        <>
            <div>
                <div className='border-b-[1px] border-[#cfcdcd] pb-1  '>
                    <h1 className='text-[#000] font-semibold text-[14px] dark:text-[#fff]'>SMTP Settings
                    </h1>
                </div>
                <div className='w-[100%] flex flex-wrap gap-4 mt-4'>
                    <div className='w-full sm:w-[48%] lg:w-[48%] flex flex-col gap-1'>
                        <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>SMTP Host</label>
                        <input

                            className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                            type="text"
                        />
                    </div>

                    <div className='w-full sm:w-[48%] lg:w-[48%] flex flex-col gap-1'>
                        <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>SMTP Port</label>
                        <input

                            className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                            type="text"
                        />
                    </div>
                    <div className='w-full sm:w-[48%] lg:w-[48%] flex flex-col gap-1'>
                        <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>SMTP Username</label>
                        <input

                            className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                            type="text"
                        />
                    </div>
                    <div className='w-full sm:w-[48%] lg:w-[48%] flex flex-col gap-1'>
                        <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>SMTP Password</label>
                        <input

                            className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                            type="text"
                        />
                    </div>
                </div>
                <div className='w-[20%]  flex  items-center justify-between gap-3 mt-2'>
                    <span
                        onClick={() => {
                            setEnableSSL(!EnableSSL)
                        }}
                        className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Enable SSL:</span>
                    <button
                        onClick={() => setEnableSSL(!EnableSSL)}
                        className={`w-[25px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${EnableSSL ? "bg-[#37715d]" : "bg-[#ef2323]"}`}>
                        <div
                            className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${EnableSSL ? "translate-x-[13px]" : ""}`}>
                        </div>
                    </button>

                </div>
                <span className='text-[#3f7fca] text-[12px]'>Note: Enable SSL is required to send emails. If disabled, emails will not be sent.
                </span>
                <button className='border-[1px] border-[#37715d] text-[#37715d] hover:bg-[#37715d] hover:text-[#fff] flex items-center text-[12px] p-2 font-semibold rounded-lg gap-1 mt-4'><FaSave />
                    Save</button>
                <div className='w-[100%] mt-1 border-t-[1px] border-[#cfcdcd] pt-3'>
                    <h1 className=' font-semibold text-[12px] dark:text-[#fff] text-[#121519]'>Test A Mail</h1>
                    <div className='border-[1px] border-[#cfcdcd w-[100%] rounded-lg pl-2 mt-2 flex items-center justify-between'>
                        <div className='flex items-center gap-1 text-[12px] text-[#535252] font-semibold dark:text-[#fff] w-[100%]  '>
                            <FaLocationArrow />
                            <input type="text"
                                className='outline-none dark:bg-[#121519] w-[90%] '
                                placeholder='For testing above SMTP settings'
                                value={testmail}
                                onChange={(e) => { settestmail(e.target.value) }}
                            />

                        </div>
                        <button className='border-[1px] border-[#37715d] text-[#fff] bg-[#37715d] hover:text-[#fff] flex items-center text-[12px] p-2 font-semibold rounded-lg gap-1 w-[100px]'><FaCodeCompare />
                            Test Now</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SMTPSetting
